<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

          <div>
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('groups.vinculo_temporal')}}</label>
            <el-form-item prop="temporal">
              <base-el-select class="w-full" :options="values" v-model="form.temporal.value" clearable :placeholder="$t('groups.vinculo_temporal_yes_no')" />
            </el-form-item>
          </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.type')}}</label>
              <el-form-item prop="tipoGrupo">
                <base-el-select class="w-full" :options="tiposGrupos" v-model="form.tipoGrupo.value" clearable filterable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.ver_todo_groups')}}</label>
              <el-form-item prop="verTodoGroups">
                <base-el-select class="w-full" :options="values" v-model="form.verTodoGroups.value" clearable :placeholder="$t('configurations.ver_todo_yes_no')" />
              </el-form-item>
            </div>
             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.ver_todo_statuses')}}</label>
              <el-form-item prop="verTodoStatuses">
                <base-el-select class="w-full" :options="values" v-model="form.verTodoStatuses.value" clearable :placeholder="$t('configurations.ver_todo_yes_no')" />
              </el-form-item>
            </div>
             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.ver_todo_companies')}}</label>
              <el-form-item prop="verTodoCompanies">
                <base-el-select class="w-full" :options="values" v-model="form.verTodoCompanies.value" clearable :placeholder="$t('configurations.ver_todo_yes_no')" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.send_alerts')}}</label>
              <el-form-item prop="send_alerts">
                <base-el-select class="w-full" :options="values" v-model="form.send_alerts.value" clearable :placeholder="$t('companies.send_alerts_yes_no')" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.send_alerts_users')}}</label>
              <el-form-item prop="enviarAvisosUsuarios">
                <base-el-select class="w-full" :options="values" v-model="form.enviarAvisosUsuarios.value" clearable :placeholder="$t('companies.send_alerts_yes_no')" />
              </el-form-item>
            </div>
              
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('users.email', 1)}}</label>
              <el-form-item prop="email">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.email.value"
                  maxlength="500"
                />
              </el-form-item>
            </div>

            <div v-if="hasPermModuleSMS">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.telefono')}}</label>
              <el-form-item prop="phone">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.phone.value"
                  maxlength="9"
                />
              </el-form-item>
            </div>

            <!--
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('companies.entity_name', 1)}}</label>
              <el-form-item prop="company">
                <el-autocomplete class="w-full" v-model="form.company.value" clearable
                :fetch-suggestions="querySearch"
                @select="handleSelect">
                  </el-autocomplete>
              </el-form-item>
            </div>
            -->
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'usergroups',
      isOpen: this.panelOpen,
      links: [],
      form: {
        id: { label: i18n.t('app.id'), value: '' },
        name: { label: i18n.t('users.entity_name'), value: '' },
        tipoGrupo: { label: i18n.t('app.type'), value: '' },
        temporal: { label: i18n.tc('groups.temporal', 1), value: '' },
        verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
        enviarAvisosUsuarios: { label: i18n.t('configurations.send_alerts_users'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        phone: { label: i18n.t('address.telefono'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS'] &&
        (this.role === 2 || this.role === 7 || this.role === 8 || this.role === 3) 
    },
    tiposGrupos: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.tipoGrupo.value = _temp.tipoGrupo !== undefined && _temp.tipoGrupo.value !== '' ? _temp.tipoGrupo.value : ''
        this.form.temporal.value = _temp.temporal !== undefined && _temp.temporal.value !== '' ? _temp.temporal.value : ''
        this.form.verTodoGroups.value = _temp.verTodoGroups !== undefined && _temp.verTodoGroups.value !== '' ? _temp.verTodoGroups.value : ''
        this.form.verTodoStatuses.value = _temp.verTodoStatuses !== undefined && _temp.verTodoStatuses.value !== '' ? _temp.verTodoStatuses.value : ''
        this.form.verTodoCompanies.value = _temp.verTodoCompanies !== undefined && _temp.verTodoCompanies.value !== '' ? _temp.verTodoCompanies.value : ''
        this.form.send_alerts.value = _temp.send_alerts !== undefined && _temp.send_alerts ? _temp.send_alerts.value : ''
        this.form.enviarAvisosUsuarios.value = _temp.enviarAvisosUsuarios !== undefined && _temp.enviarAvisosUsuarios ? _temp.enviarAvisosUsuarios.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.phone.value = _temp.phone !== undefined && _temp.phone.value !== '' ? _temp.phone.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('app.id'), value: '' },
        name: { label: i18n.t('users.entity_name'), value: '' },
        tipoGrupo: { label: i18n.t('app.type'), value: '' },
        temporal: { label: i18n.tc('groups.temporal', 1), value: '' },
        verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
        enviarAvisosUsuarios: { label: i18n.t('configurations.send_alerts_users'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        phone: { label: i18n.t('address.telefono'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectRole: function (item) {
      this.form.role.value = item.id
    },
    handleSelectTipoAuth: function (item) {
      this.form.tipoAuth.value = item.id
    }
  }
}
</script>
